import {gnv, snv} from "@Common/utils/arr-path";
import {reverse}  from "@Common/utils/collections";
import {chain2}   from "@Common/utils/fs";
import {omit}     from "@Common/utils/objects";

export const alterPrepareSaveValue = (prepareSave, changes) => (
    (input) => {
        let convertOutputs = [];
        for (const change of changes) {
            const {convertedInput, convertOutput} = change(input);
            input = convertedInput;
            convertOutputs.push(convertOutput);
        }
        const {newValue, ...others} = prepareSave(input);
        return {
            ...others,
            newValue: chain2(
                newValue,
                reverse(convertOutputs),
            ),
        };
    }
);

export const nestData = (path) => (input) => ({
    convertedInput: gnv(input, path),
    convertOutput: (output) => snv(input, path, output),
});

export const renameAttrs = (changes) => (input) => ({
    convertedInput: !input ? input : chain2(input, changes.map(({outside, inside}) => (
        (_) => ({
            ...omit(_, [outside]),
            [inside]: _[outside],
        })
    ))),
    convertOutput: (output) => !output ? output : chain2(output, changes.map(({outside, inside}) => (
        (_) => ({
            ...omit(_, [inside]),
            [outside]: _[inside],
        })
    ))),
});

